export default "__VITE_ASSET__D$0TM5E1__"